module.exports = __webpack_public_path__ + "img/som.f91fb92c.svg";